import React from 'react';
import PropTypes from 'prop-types';

// Styles
import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const PriceTextBlock = ({ price, discount, indSaleConnected }) => {
  if (indSaleConnected) {
    return (
      <>
        {price && price.toLowerCase() !== 'бесплатно' && (
          <span
            dangerouslySetInnerHTML={{ __html: price }}
            className={cx('line-through')}
          />
        )}
        <span>Бесплатно</span>
      </>
    );
  }

  if (price && discount) {
    return (
      <>
        {price && price.toLowerCase() !== 'бесплатно' && (
        <span
          dangerouslySetInnerHTML={{ __html: price }}
          className={cx('line-through')}
        />
        )}
        <span dangerouslySetInnerHTML={{ __html: discount }} />
      </>
    );
  }

  return (
    <span dangerouslySetInnerHTML={{ __html: price }} />
  );
};

PriceTextBlock.propTypes = {
  price: PropTypes.string,
  discount: PropTypes.string,
  indSaleConnected: PropTypes.bool,
};

export default PriceTextBlock;
